import React from 'react'
import { StyledSection } from '../StyledSections'

const GoalsSection = ({ goals }) => {
    return (
        <StyledSection title="Goals" className="half-height">
            {goals && (
                <div className="goal-item">
                    {goals}
                </div>
            )}
        </StyledSection>
    )
}

export default GoalsSection 
